export default __webpack_public_path__ + "static/media/contactsBlue.e1eaa251.svg";